export default `
clip-path: polygon(40% 0%, 40% 15%, 100% 15%, 100% 85%, 40% 85%, 40% 100%, 0% 50%);
`
